<app-loading class="full-width-height" [type]="'links'" [setReady]="ready"></app-loading>